import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Drawer, DrawerContent } from "@/components/ui/drawer";

export function useIsMobile() {
  const [mobile, setMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches
  );
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const handler = (e) => setMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return mobile;
}

/** Dialog on desktop, swipe-to-dismiss bottom sheet on mobile. */
export default function ResponsiveModal({ open, onOpenChange, title, description, children, footer, testid, className = "" }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className={`bg-surface-elevated max-h-[92dvh] ${className}`} data-testid={testid}>
          <div className="flex flex-col min-h-0 max-h-[88dvh]">
            <div className="px-4 pt-1 pb-2 shrink-0">
              <div className="font-serif-display text-2xl text-primary">{title}</div>
              {description && <div className="text-sm text-muted-foreground mt-0.5">{description}</div>}
            </div>
            <div className="px-4 flex-1 overflow-y-auto scrollbar-thin">{children}</div>
            {footer && (
              <div className="px-4 pt-3 pb-[calc(1rem+env(safe-area-inset-bottom))] shrink-0 border-t border-border flex flex-col gap-2 bg-surface-elevated">
                {footer}
              </div>
            )}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`rounded-3xl ${className}`} data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">{title}</DialogTitle>
          <DialogDescription className={description ? "" : "sr-only"}>{description || `${title} dialog`}</DialogDescription>
        </DialogHeader>
        {children}
        {footer && <DialogFooter className="gap-2">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
